import * as Sentry from "@sentry/gatsby"
import { CaptureContext } from "@sentry/types"

export const captureException = (
  exception: any,
  captureContext?: CaptureContext | undefined
) => {
  if (process.env.GATSBY_NODE_ENV === "development") {
    console.log("Logging error to sentry!")
    console.log(exception)
  } else {
    let session_id: string = ""
    if (
      typeof window !== "undefined" &&
      localStorage &&
      typeof localStorage !== "undefined"
    ) {
      const user = localStorage.getItem("hg::cache::user")
      session_id = user ? JSON.parse(user).session_id : ""
    }
    Sentry.captureException(exception, {
      ...captureContext,
      tags: {
        ...(captureContext as any)?.tags,
        version: process.env.GATSBY_APP_VERSION,
        ...(session_id && { sessionId: session_id }),
      },
    })
  }
}
